import React, { FC } from "react";
import "./title.css";
import { TitleSkeleton } from "./title.skeleton";

interface TitleProps {
  text?: string;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5";
  className?: string;
  loading?: boolean;
}

/**
 * Title component
 */
export const Title: FC<TitleProps> = ({
  text,
  tag = "h3",
  className,
  loading,
}) => {
  if (!text) {
    return null;
  }

  // if (loading) {
  if (loading) {
    return <TitleSkeleton tag={tag} />;
  }

  return React.createElement(tag, { className }, text);
};
